import { CheckCircleIcon, XCircleIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { ERROR_SYNC, SUCCESS_SYNC } from "../../consts/quickBooksTypes";

export const getValidationByPO = (po) => {
    if (!po?.lineItems || !Array.isArray(po?.lineItems) || po?.lineItems?.length < 1) return { success: false, error: `PO line items is invalid.` };
    const lineItemsErrors = [];
    po.lineItems.forEach((item) => {
        if (!item.Product?.name || !item.Product?.sku) {
            lineItemsErrors.push(`${item.line_item_id} - has invalid product name or sku.`)
        }
    });
    if (lineItemsErrors.length > 0) return { success: false, error: lineItemsErrors.join(", ")};
    if (!po?.poNumber) return { success: false, error: `PO number is invalid.` };
    return { success: true, error: null };
};

export const NotificationIcon = ({
    errorText,
    clickOnIcon,
    status,
    po
}) => {
    const validationPO = getValidationByPO(po);
    const success = validationPO.success;
    const error = validationPO.error;
    const tooltipTitle = 
        status === ERROR_SYNC ? "QB synced with errors" :
        !success ? "Invalid data to sync for the QB" : null;
    const clickFunction = () => {
        if (!success || status === ERROR_SYNC) {
            clickOnIcon(`
                ${tooltipTitle ? `<h4 class="text-lg whitespace-break-spaces mb-2">${tooltipTitle}</h4>` : ""}
                ${errorText || error ? `<div class="break-words whitespace-break-spaces">Error: ${errorText || error}</div>` : ""} 
            `);
        }
    };
    return (
        <>
            <button
                onClick={clickFunction}
                className="relative z-20"
            >
                {status === SUCCESS_SYNC ? (
                    <CheckCircleIcon className="h-4 w-4 text-green-700" />
                ) : status === ERROR_SYNC ? (
                    <XCircleIcon className="h-4 w-4 text-red-700" />
                ) : !success ? (
                    <XCircleIcon className="h-4 w-4 text-red-700" />
                ) : success ? (
                    <InformationCircleIcon className="h-4 w-4 text-yellow-700" />
                ) : null}
            </button>
        </>

    )
}